import { render } from "./uploadContract.vue?vue&type=template&id=0397bf67&scoped=true"
import script from "./uploadContract.vue?vue&type=script&lang=js"
export * from "./uploadContract.vue?vue&type=script&lang=js"

import "./uploadContract.vue?vue&type=style&index=0&id=0397bf67&scoped=true&lang=less"

import exportComponent from "D:\\wkb\\dev\\study\\盘雷\\lida-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0397bf67"]])

export default __exports__